<mat-dialog-content >
    <div fxLayoutAlign="space-between center">
        <h2>Add Corporate Group</h2>
        <button mat-raised-button color="warn" (click)="deleteElemenet()" *ngIf="data">Delete</button>
    </div>
    <form [formGroup]="userCorporateVehicleForm" (ngSubmit)="onSubmit()" autocomplete="off" fxLayout="column"
        fxLayoutAlign=" none">

        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name">
        </mat-form-field>
        <div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                Corporates
                <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" type="button"
                    (click)="addCorporate()"><mat-icon>add_circle</mat-icon></button>
            </div>
            <div *ngFor="let element of userCorporateVehicleForm.get('corporates').value; let i = index">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p>{{ element.id }} - {{ element.name }} </p>
                    <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" type="button"
                        (click)="removeCorporate(i)"><mat-icon>remove_circle</mat-icon></button>
                </div>
            </div>
        </div>
        <hr>
        <div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                Vehicles
                <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" type="button"
                    (click)="addVehicle()"><mat-icon>add_circle</mat-icon></button>
            </div>
            <div *ngFor="let element of userCorporateVehicleForm.get('vehicles').value; let i = index">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p>{{ element.id }} - {{ element.name }} </p>
                    <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" type="button"
                        (click)="removeVehicle(i)"><mat-icon>remove_circle</mat-icon></button>
                </div>
            </div>
        </div>
        <button type="submit" mat-raised-button color="primary"
            [disabled]="!userCorporateVehicleForm.valid">Save</button>

    </form>
</mat-dialog-content>